import { render } from "./MoveableModal.vue?vue&type=template&id=0c7b3b31"
import script from "./MoveableModal.vue?vue&type=script&lang=js"
export * from "./MoveableModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__